import { useGetOrder } from 'api/orders';
import { SimpleResponse } from 'components/pages/OtpRedirectPage/OtpRedirectPage';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export type SimpleStatus =
  | 'FINISHED'
  | 'AUTHORIZED'
  | 'REFUND'
  | 'REVERSED'
  | 'CANCELLED'
  | 'TIMEOUT';

export type WSMessageData = {
  merchantCode: string;
  merchantSecret: string;
  orderRef: string;
  status: SimpleStatus;
  transactionCode: string;
};

const useOrderStatusPage = () => {
  const [status, setStatus] = useState<SimpleStatus>();
  const { orderRef } = useParams();
  const { data: orderData, isLoading: isOrderDataLoading } = useGetOrder(orderRef);
  const navigate = useNavigate();
  const simpleResponse = localStorage.getItem('otp');
  const webSocket = useRef<WebSocket | null>(null);

  if (!simpleResponse) {
    throw new Error('No otp data found');
  }

  useEffect(() => {
    if (!webSocket.current) {
      const response = JSON.parse(simpleResponse) as SimpleResponse;
      const wsProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
      let wsURI: string;
      if (process.env.NODE_ENV === 'development') {
        wsURI = `wss://parwebdev.intranet.parola.hu/parweb-web-gw-v1/websocket/${response.t}`;
      } else {
        wsURI = `${wsProtocol}://${window.location.host}${process.env.REACT_APP_WS_URL}/${response.t}`;
      }
      webSocket.current = new WebSocket(wsURI);
      webSocket.current.onmessage = (message: MessageEvent<string>) => {
        const data = JSON.parse(message.data) as WSMessageData;
        // eslint-disable-next-line no-console
        console.log(JSON.stringify(data));
        setStatus(data.status);
      };
    }
  }, [simpleResponse]);

  const goToOrderPage = () => {
    navigate('..');
  };

  const goToMerchantPage = () => {
    if (!orderData) return;
    window.location.href = orderData.backUrl;
  };

  const goToTap = () => {
    if (!orderData) return;
    window.location.href = 'https://www.tapertekszamitas.hu';
  };

  return {
    simpleResponse: JSON.parse(simpleResponse) as SimpleResponse,
    goToOrderPage,
    status,
    setStatus,
    orderData,
    isOrderDataLoading,
    goToMerchantPage,
    goToTap
  };
};

export default useOrderStatusPage;
